export const countryGroups = {
    north_africa: [
      'DZ', 'LY', 'TN',
    ],
  
    wild_africa: [
      'BW', 'KE', 'MZ', 'TZ', 'ZW', 'SZ',
    ],
  
    west_africa: [
      'GA', 'GM', 'CI', 'LR', 'SN', 'SL', 'EH',
    ],
  
    african_landscapes: [
      'AO', 'BJ', 'CM', 'CF', 'TD', 'CD', 'DJ',
      'GQ', 'ER', 'ET', 'GH', 'CG', 'SS', 'SD',
      'TG', 'BF', 'GN', 'GW', 'MW', 'ML', 'MR',
      'NE', 'NG',
    ],
  
    central_africa: [
      'BI', 'RW', 'UG',
    ],
  
    central_america: [
      'SV', 'GF', 'GP', 'GT', 'GY', 'HN', 'NI',
      'PA', 'PY', 'SR',
    ],
  
    glaciers: [
      'AR', 'CL', 'UY',
    ],
  
    mediterranian: [
      'AL', 'CY', 'GR', 'MT', 'MC', 'ME',
    ],
  
    alpins_pirreneans: [
      'AD', 'AT', 'CH', 'SM',
    ],
  
    eastern_europe: [
      'BA', 'HR', 'CZ', 'HU', 'XK', 'MK', 'MD',
      'RO', 'RS', 'SK', 'SI',
    ],
  
    europe: [
      'BE', 'DK', 'LI', 'LU', 'NL',
    ],
  
    karelia: [
      'AX', 'FI',
    ],
  
    baltic: [
      'EE', 'LV', 'LT', 'PL', 'SE',
    ],
  
    polynesia: [
      'AS', 'CK', 'TL', 'FJ', 'PF', 'GU', 'KI',
      'MH', 'FM', 'NR', 'NC', 'TO', 'TV', 'VU',
      'WF', 'NU', 'MP', 'PW', 'PG', 'PH', 'SB', 'TK',
    ],
  
    caribbean: [
      'AI', 'AG', 'AW', 'BS', 'BB', 'BZ', 'BM',
      'BQ', 'VG', 'KY', 'CR', 'KN', 'LC', 'MF',
      'VC', 'SX', 'TT', 'TC', 'VI', 'DO', 'CW',
      'DM', 'HT', 'JM', 'MQ', 'PR', 'BL', 'GD',
    ],
  
    tropical_islands: [
      'MV', 'MU', 'YT', 'RE', 'WS', 'ST', 'SC',
      'IO', 'CC',
    ],
  
    arabian: [
      'BH', 'IQ', 'JO', 'KW', 'OM', 'PS', 'QA', 'SA',
    ],
  
    himalayan: [
      'BT', 'NP', 'PK', 'TJ',
    ],
  
    muslim_asia: [
      'BN', 'ID', 'MY', 'BD',
    ],
  
    buddha_asia: [
      'KH', 'LA', 'MM', 'TH', 'VN',
    ],
  
    island_life: [
      'CV', 'CX', 'KM', 'GG', 'MS', 'SH',
    ],
  
    cold_islands: [
      'BV', 'FK', 'TF', 'HM', 'IM', 'JE', 'PN',
      'GS', 'SJ', 'NF',
    ],
  
    greenland_iceland: [
      'GL', 'IS', 'PM',
    ],
  
    cliffs: [
      'FO', 'IE',
    ],
  
    steppe: [
      'KZ', 'KG', 'MN', 'TM',
    ],
  
    east_asian_hubs: [
      'HK', 'MO', 'TW',
    ],
  };